<template>
  <div>
    <div v-show="!isLoaded">
      <spin-loader />
    </div>
    <div v-show="isLoaded">
      <b-row class="justify-content-center">
        <b-col
          cols="12"
          md="12"
          lg="12"
        >
          <b-card
            no-body
            class="mb-0"
          >

            <div class="m-2">

              <!-- Table Top -->
              <b-row>

                <!-- Per Page -->
                <b-col
                  cols="12"
                  md="6"
                  class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                >
                  <div>
                    <b-form-group
                      label="Exibir"
                      label-for="idSearchBox"
                      class="mb-0"
                    >
                      <v-select
                        id="idSearchBox"
                        v-model="perPage"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="perPageOptions"
                        :clearable="false"
                        class="per-page-selector d-inline-block"
                      >
                        <span slot="no-options">Não há opções para essa quantidade.</span>
                      </v-select>
                    </b-form-group>
                  </div>
                  <b-form-input
                    v-model.lazy="searchQuery"
                    placeholder="Buscar"
                    type="text"
                    class="d-inline-block mt-2 ml-1"
                  />
                </b-col>
              </b-row>
            </div>
            <b-table
              class="position-relative"
              primary-key="id"
              responsive
              show-empty
              striped
              hover
              empty-text="Não há empresas cadastradas."
              :items="companies"
              :fields="tableColumns"
              :sort-by.sync="sortBy"
              :sort-desc.sync="isSortDirDesc"
              @row-clicked="onRowSelected"
            >
              <template #cell(id)="data">
                <b-media vertical-align="center">
                  <b-link
                    class="font-weight-bold d-block text-nowrap"
                    @click="onRowSelected(data.item)"
                  >
                    #{{ data.item.id }}
                  </b-link>
                </b-media>
              </template>

              <!-- Column: Name -->
              <template #cell(corporate_name)="data">
                <b-media vertical-align="center">
                  <div
                    class="d-block text-nowrap font-weight-bold"
                  >
                    {{ data.item.corporate_name }}
                  </div>
                </b-media>
              </template>

              <!-- Column: CNPJ -->
              <template #cell(cnpj)="data">
                <div
                  v-if="data.item.cnpj"
                  class="d-block text-nowrap"
                >
                  {{ data.item.cnpj | VMask('##.###.###/####-##') }}
                </div>
                <div v-else>
                  <span class="font-weight-bold">-</span>
                </div>
              </template>

              <!-- Column: IE-->
              <template #cell(ie)="data">
                <b-media vertical-align="center">
                  <div
                    v-if="data.item.ie"
                    class="d-block text-nowrap"
                  >
                    {{ data.item.ie }}
                  </div>
                  <div v-else>
                    <span class="font-weight-bold">-</span>
                  </div>
                </b-media>
              </template>

              <!-- Column: Phone  -->
              <template #cell(phone_number)="data">
                <div
                  v-if="data.item.phone_number"
                  class="d-block text-nowrap"
                >
                  {{ data.item.phone_number }}
                </div>
                <div v-else>
                  <span class="font-weight-bold">-</span>
                </div>
              </template>

              <!-- Column: Actions -->
              <template #cell(field_actions)="data">
                <div
                  :class="totalItems > 1 ? '' : 'dropdownfix'"
                >
                  <b-dropdown
                    variant="link"
                    no-caret
                    :dropup="true"
                    :boundary="'scrollParent'"
                    :right="$store.state.appConfig.isRTL"
                  >

                    <template #button-content>
                      <feather-icon
                        icon="MoreVerticalIcon"
                        size="16"
                        class="align-middle text-body"
                      />
                    </template>
                    <b-dropdown-item
                      :to="{ name: 'company-detail', params: { id: data.item.id } }"
                    >
                      <feather-icon icon="FileTextIcon" />
                      <span class="align-middle ml-50">Detalhes</span>
                    </b-dropdown-item>

                    <b-dropdown-item
                      :disabled="!hasPermissionToUpdate"
                      :to="{ name: 'company-edit', params: { id: data.item.id } }"
                    >
                      <feather-icon icon="EditIcon" />
                      <span class="align-middle ml-50">Editar</span>
                    </b-dropdown-item>

                    <b-dropdown-item
                      :disabled="!hasPermissionToDelete"
                      @click="showConfirmOrCancelDelete(data.item)"
                    >
                      <svg-icon
                        type="mdi"
                        size="16"
                        :path="mdiTrashCanOutline"
                      />
                      <span class="align-middle ml-50">Remover</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </template>
            </b-table>
            <div class="mx-2 mb-2">
              <b-row>
                <b-col
                  cols="12"
                  class="d-flex align-items-center justify-content-center"
                >

                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalItems"
                    :per-page="perPage"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                  >
                    <template #prev-text>
                      <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                      />
                    </template>
                    <template #next-text>
                      <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                      />
                    </template>
                  </b-pagination>

                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <div>
        <b-button
          id="addCompanyBtn"
          v-b-tooltip.hover
          class="btn-icon rounded-circle m-3"
          variant="primary"
          size="md"
          :to="{ name: 'company-create'}"
          :disabled="!hasPermissionToWrite"
          title="Adicionar empresa"
        >
          <svg-icon
            type="mdi"
            :path="mdiPlus"
          />
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BFormInput,
  BFormGroup,
  BRow,
  BCol,
  BButton,
  BTable,
  BMedia,
  BLink,
  BDropdown,
  BDropdownItem,
  BPagination,
  VBTooltip,
} from 'bootstrap-vue'

import {
  mdiPlus,
  mdiTrashCanOutline,
} from '@mdi/js'

import {
  useToast,
} from 'vue-toastification/composition'

import SvgIcon from '@jamescoyle/vue-icon'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router'
import syslic from '@/syslic'
import SpinLoader from '@/components/spinloader/SpinLoader.vue'

export default {
  components: {
    BCard,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BButton,
    BTable,
    BMedia,
    BLink,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    SpinLoader,
    SvgIcon,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    const perPage = 10
    const totalItems = 0
    const currentPage = 1
    const searchQuery = ''
    const sortBy = 'corporate_name'
    const isSortDirDesc = false
    const perPageOptions = [10, 25, 50, 100]

    const tableColumns = [
      {
        key: 'id',
        label: 'Id',
        sortable: true,
      },
      {
        key: 'corporate_name',
        label: 'Nome',
        sortable: true,
      },
      {
        key: 'cnpj',
        label: 'CNPJ',
        sortable: true,
      },
      {
        key: 'ie',
        label: 'IE',
        sortable: true,
      },
      {
        key: 'phone_number',
        label: 'Telefone',
        sortable: true,
      },
      {
        key: 'field_actions',
        label: '',
      },
    ]

    const companies = []
    const isLoaded = false

    return {
      perPage,
      totalItems,
      currentPage,
      searchQuery,
      sortBy,
      isSortDirDesc,
      perPageOptions,
      tableColumns,
      companies,
      isLoaded,
    }
  },
  computed: {
    hasPermissionToRead() {
      const profile = syslic.authentication.getProfile()
      return profile.get_permissions_for_modules.user.can_read
    },
    hasPermissionToWrite() {
      const profile = syslic.authentication.getProfile()
      return profile.get_permissions_for_modules.company.can_write
    },
    hasPermissionToUpdate() {
      const profile = syslic.authentication.getProfile()
      return profile.get_permissions_for_modules.company.can_edit
    },
    hasPermissionToDelete() {
      const profile = syslic.authentication.getProfile()
      return profile.get_permissions_for_modules.company.can_delete
    },
  },
  watch: {
    perPage: 'fetchData',
    currentPage: 'fetchData',
    searchQuery: function updateSearchQuery(value) {
      this.currentPage = 1
      this.searchQuery = value
      this.fetchData()
    },
    sortBy: 'fetchData',
    isSortDirDesc: 'fetchData',
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      const params = {
        p: this.currentPage,
        page_size: this.perPage,
        search: this.searchQuery,
      }

      if (this.isSortDirDesc) {
        params.ordering = `-${this.sortBy}`
      } else {
        params.ordering = this.sortBy
      }

      syslic
        .company
        .fetchCompanyList(params)
        .then(response => {
          this.totalItems = response.data.count
          this.companies = response.data.results
          this.isLoaded = true
        })
        .catch(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Falha ao ler os dados das empresas.',
              text: 'Não foi possível ler os dados das empresas do servidor, por favor entre em contato com o administrador do sistema.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              timeout: false,
            },
          })
          this.isLoaded = true
        })
    },
    deleteCompany(item) {
      syslic
        .company
        .deleteCompany(item.id)
        .then(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Empresa removida com sucesso.',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
          this.companies.splice(this.companies.indexOf(item), 1)
        })
        .catch(error => {
          let textError = 'Não foi possível remover esta empresa, por favor entre em contato com o administrador do sistema.'

          if ('data' in error) {
            if (error.data.includes('they are referenced through protected foreign keys')) {
              textError = 'Esta empresa é referenciada em alguma licitação, por este motivo não será possível exclui-la.'
            }
          }

          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Falha ao remover empresa.',
              text: textError,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              timeout: false,
            },
          })
        })
    },
    showConfirmOrCancelDelete(item) {
      this.$bvModal
        .msgBoxConfirm('Por favor, confirme que você quer remover a empresa.', {
          id: 'confirmation_box',
          title: 'Confirmar?',
          size: 'sm',
          okVariant: 'primary',
          okTitle: 'Sim',
          cancelTitle: 'Não',
          cancelVariant: 'outline-primary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value) {
            this.deleteCompany(item)
          }
        })
    },
    onRowSelected(item) {
      router.push({ name: 'company-detail', params: { id: item.id } }).catch(() => {})
    },
  },
  setup() {
    const toast = useToast()

    return {
      toast,
      mdiPlus,
      mdiTrashCanOutline,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.dropdownfix .dropdown.show{
  position: fixed;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#addCompanyBtn {
  position: fixed;
  right: 0;
  bottom: 0;
}
</style>
